import React, { useState, useEffect } from "react";
import VinInfo from "./VinInfo";
import { formatPoilcyDate } from "../../../shared/dateFormat";
import classNames from "classnames";
import InfoToolTip from "../../InfoToolTip/InfoToolTip";
import { Event as CalendarEvent } from "@material-ui/icons";
import { getPolicyInfo } from "../../../services/policy.service";
import { searchResultModel } from "../../../models/policy.model";
const content = (warnings) => {
  return (
    <div>
      {warnings.map((warning) => {
        return <div className={"p-1"}>{warning}</div>;
      })}
    </div>
  );
};
const reminderContent = (agentCode, agentPhoneNo) => {
  return (
    <div>
      <div className={"p-1"}>
        <span className={" calendar-diary-description calendar-diary"}>
          Phone:
        </span>
        <span className={"calendar-diary"}> {agentPhoneNo} </span>
      </div>
      <div className={"p-1"}>
        <span className={"calendar-diary-description"}> Code: </span>
        <span className={"calendar-diary"}> {agentCode} </span>
      </div>
    </div>
  );
};

const diaryListContent = (diaryList) => {
  return (
    <>
      {diaryList.length > 0 &&
        diaryList.splice(0, 1).map((diary) => {
          return (
            <div className={"p-2"}>
              <div className={"flex-box pb-1"}>
                <div className={"calendar-diary pr-1"}>{diary.location} </div>
                <div className={"calendar-diary-date"}>
                  {formatPoilcyDate(diary.startTime)}{" "}
                </div>
              </div>
              <div className={"calendar-diary-description pt-1"}>
                {diary.description}
              </div>
            </div>
          );
        })}
    </>
  );
};
const getSearchParameter = () => {
  let type = localStorage.getItem("searchElement");
  return type;
};
const getHighlightedText = (text, highlight) => {
  // Split text on highlight term, include term itself into parts, ignore case
  if (text) {
    let parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts.map((part) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span style={{ background: "yellow" }}>{part}</span>
          ) : (
            part
          ),
        )}
      </span>
    );
  }
};

export default function SearchList(props) {
  const [policyNo] = props.data;
  // const [data, isLoading] = useGetResources(
  //   "get/policy/search/details?policyNo=" + policyNo,
  // );
  const { defaultSearchValue } = props;
  // const {
  //   effDate,
  //   policyStatus,
  //   agentCode,
  //   agentPhoneNo,
  //   agencyName,
  //   expDate,
  //   ins1FullName,
  //   warnings,
  //   diaryFlag,
  //   warningsCount,
  //   diaryList,
  // } = data;
  const [policyDetails, setPolicyDetails] = useState(searchResultModel);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  useEffect(() => {
    let isMounted = true;
    setIsLoading(true); // note this flag denote mount status
    getPolicyInfo(policyNo)
      .then((data) => {
        setIsLoading(false);
        if (data.data.statusCode === 200) {
          if (isMounted) {
            setPolicyDetails(data.data.response);
          }
        } else {
          setErrorMessage("Something Went Wrong...!");
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
    return () => {
      isMounted = false;
      setIsLoading(false);
    }; // use effect cleanup to set flag false, if unmounted
  }, []);

  return (
    <div key={policyNo} className="card mb-2" style={{ border: "none" }}>
      <div
        className={"card-body"}
        style={{
          height: "auto",
          borderRadius: "4px",
          padding: "1.25rem 1rem 1.25rem 1rem",
        }}
      >
        {isLoading ? (
          <div>Loading...</div>
        ) : errorMessage !== null ? (
          <div className={"text-center"}>
            <div className={"search-error"}>{errorMessage}</div>
          </div>
        ) : (
          <div>
            <div
              className={"flex-box"}
              style={{ padding: " 0px 0px 0px 10px" }}
            >
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Policy No</div>
                <div
                  className={"search-items-content actionIcon"}
                  style={{ color: "#03a9f4" }}
                  onClick={() => {
                    window.open("/#/app/policy-view/" + policyNo, "_blank");
                  }}
                >
                  {getSearchParameter() === "policyNo"
                    ? getHighlightedText(policyNo, defaultSearchValue)
                    : policyNo}
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Phone No.</div>
                <div className={"search-items-content"}>
                  {policyDetails.homePhone}
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Effective Date</div>
                <div className={"search-items-content"}>
                  {formatPoilcyDate(policyDetails.effDate)}
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Status</div>
                <div>
                  <span
                  title={policyDetails.policyStatus}
                    className={classNames({
                      "active-status": policyDetails.policyStatus === "ACTIVE",
                      "suspended-status":
                        policyDetails.policyStatus === "CANCEL",
                      "new-status": policyDetails.policyStatus === "NEW",
                      "notice-status": policyDetails.policyStatus === "NOTICE",
                      "expired-status":
                        policyDetails.policyStatus === "EXPIRED",
                    })}
                  >
                    {policyDetails.policyStatus}
                  </span>
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Ageny Name </div>
                <div className={"search-items-content actionIcon"}>
                  <InfoToolTip
                    title={
                      <span style={{ color: "#03a9f4" }}>
                        {policyDetails.agencyName}{" "}
                      </span>
                    }
                    color={"#212121"}
                    bgColor={"#e1f5fe"}
                    borderColor={"#03a9f4"}
                    content={reminderContent(
                      policyDetails.agentCode,
                      policyDetails.agentPhoneNo,
                    )}
                  />
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Expiration Date</div>
                <div className={"search-items-content"}>
                  {formatPoilcyDate(policyDetails.expDate)}
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"search-label"}>Insured</div>
                <div className={"search-items-content"}>
                  {getSearchParameter() === "insuredName"
                    ? getHighlightedText(
                        policyDetails.ins1FullName,
                        defaultSearchValue,
                      )
                    : policyDetails.ins1FullName}
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div className={"actionIcon"}>
                  {policyDetails.diaryFlag ? (
                    <span style={{ color: "#03a9f4", paddingRight: "10px" }}>
                      <InfoToolTip
                        title={<CalendarEvent color="colorDisabled" />}
                        color={"#212121"}
                        bgColor={"#e1f5fe"}
                        borderColor={"#03a9f4"}
                        content={diaryListContent(policyDetails.diaryList)}
                      />
                    </span>
                  ) : null}
                  {policyDetails.warningsCount > 0 ? (
                    <span
                      className={classNames({
                        "warnings-container": true,
                      })}
                    >
                      <InfoToolTip
                        title={policyDetails.warningsCount}
                        color={"#c62828"}
                        bgColor={"#ffebee"}
                        borderColor={"#d32f2f"}
                        content={content(policyDetails.warnings)}
                      />
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
            <div>
              <VinInfo
                key={policyNo}
                {...props}
                data={policyDetails}
                isLoading={isLoading}
                defaultSearchValue={defaultSearchValue}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
